import { mainStore } from "../mainStore";
import { GAME_IDS } from "../constants/gameIds";
import { plinkoTKeys } from "../games/plinko/constants/plinkoTKeys";
import { limboTKeys } from "../games/limbo/constants/limboTKeys";
import { wheelTKeys } from "../games/wheel/constants/wheelTKeys";
import { chickenTKeys } from "../games/chicken/constants/chickenTKeys";
import { chickenChristmasTKeys } from "../games/chicken-christmas/constants/chickenTKeys";
import { chickenWinterTKeys } from "../games/chicken-winter/constants/chickenTKeys";
import { minesTKeys } from "../games/mines/constants/minesTKeys";
import { halloweenMinesTKeys } from "../games/halloween-mines/constants/minesTKeys";
import { plinkoAztecTKeys } from "../games/plinko-aztec/constants/plinkoTKeys";
import { limboRocketTKeys } from "../games/limbo-rocket/constants/limboTKeys";
import { rouletteTKeys } from "../games/roulette/constants/rouletteTKeys";
import { twistTKeys } from "../games/twist/constants/TKeys";
import { twistClassicTKeys } from "../games/twist-classic/constants/TKeys";
import { towerCrashTKeys } from "../games/tower-crash/constants/TKeys";
import { chickenMinesTKeys } from "../games/chicken-mines/constants/minesTKeys";
import { balloonTKeys } from "../games/balloon/constants/TKeys";
import { camelCrashTKeys } from "../games/camel-crash/constants/TKeys";
import containerCrashTKeys from "../games/container-crash/constants/TKeys";
import chickenFootballTKeys from "../games/chicken-football/constants/TKeys";
import diceTKeys from "../games/dice/constants/TKeys";
import candyTowerTKeys from "../games/candy-tower/constants/TKeys";
import coinFlipTKeys from "../games/coin-flip/constants/TKeys";

const TKeysByGameId = {
  [GAME_IDS.PLINKO]: plinkoTKeys,
  [GAME_IDS.LIMBO]: limboTKeys,
  [GAME_IDS.WHEEL]: wheelTKeys,
  [GAME_IDS.CHICKEN]: chickenTKeys,
  [GAME_IDS.CHICKEN_CHRISTMAS]: chickenChristmasTKeys,
  [GAME_IDS.CHICKEN_BRANDED]: chickenTKeys,
  [GAME_IDS.CHICKEN_WINTER]: chickenWinterTKeys,
  [GAME_IDS.MINES]: minesTKeys,
  [GAME_IDS.HALLOWEEN_MINES]: halloweenMinesTKeys,
  [GAME_IDS.PLINKO_AZTEC]: plinkoAztecTKeys,
  [GAME_IDS.LIMBO_ROCKET]: limboRocketTKeys,
  [GAME_IDS.ROULETTE]: rouletteTKeys,
  [GAME_IDS.TWIST]: twistTKeys,
  [GAME_IDS.TWIST_CLASSIC]: twistClassicTKeys,
  [GAME_IDS.TOWER_CRASH]: towerCrashTKeys,
  [GAME_IDS.CHICKEN_MINES]: chickenMinesTKeys,
  [GAME_IDS.BALLOON]: balloonTKeys,
  [GAME_IDS.CAMEL_CRASH]: camelCrashTKeys,
  [GAME_IDS.CONTAINER_CRASH]: containerCrashTKeys,
  [GAME_IDS.CHICKEN_FOOTBALL]: chickenFootballTKeys,
  [GAME_IDS.DICE]: diceTKeys,
  [GAME_IDS.CANDY_TOWER]: candyTowerTKeys,
  [GAME_IDS.COIN_FLIP]: coinFlipTKeys,
};

class TranslationService {
  TKeys = TKeysByGameId[mainStore.gameId];

  t(key, ...values) {
    let value = mainStore.translations[key];

    if (!value) {
      return key;
    }

    for (let i = 0; i < values.length; i++) {
      value = value.split("{" + i + "}").join(values[i]);
    }

    return value;
  }
}

export const translationService = new TranslationService();
